import { Button, Input } from "@tellescope/ui";
import { Plus, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { FieldRestrictionList as FieldRestrictionListKey } from "./roleEditorConfig";
import { RoleEditor } from "./useEditRoleDialog";

export interface FieldRestrictionListProps {
  list: FieldRestrictionListKey;
  label: string;
  description: string;
  editor: RoleEditor;
}

export const FieldRestrictionList = ({ list, label, description, editor }: FieldRestrictionListProps) => {
  const { t } = useTranslation("settings");
  const { draft, addFieldRestriction, updateFieldRestriction, removeFieldRestriction } = editor;
  const entries = draft.uiRestrictions[list] ?? [];

  return (
    <div className="space-y-2">
      <div className="space-y-0.5">
        <h4 className="text-sm font-medium">{label}</h4>
        <p className="text-xs text-muted-foreground">{description}</p>
      </div>
      <div className="space-y-2">
        {entries.map((entry, index) => (
          // eslint-disable-next-line react/no-array-index-key -- entries are positional and have no stable id
          <div key={`${list}-${index}`} className="flex items-center gap-2">
            <Input
              value={entry.type ?? ""}
              onChange={(e) => updateFieldRestriction(list, index, "type", e.target.value)}
              placeholder={t("Contact type (optional)")}
              className="h-8"
            />
            <Input
              value={entry.field ?? ""}
              onChange={(e) => updateFieldRestriction(list, index, "field", e.target.value)}
              placeholder={t("Field")}
              className="h-8"
            />
            <Button
              variant="outline"
              className="h-8 w-8 p-0 shrink-0"
              onClick={() => removeFieldRestriction(list, index)}
              hoverLabel={t("Remove")}
            >
              <Trash2 strokeWidth={1.8} className="text-destructive" />
            </Button>
          </div>
        ))}
      </div>
      <Button variant="outline" size="sm" className="text-xs" onClick={() => addFieldRestriction(list)}>
        <Plus strokeWidth={1.8} className="h-4 w-4" />
        {t("Add field")}
      </Button>
    </div>
  );
};
